import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export type ShareIconProps = IconProps;

export const ShareIcon: FC<ShareIconProps> = ({ iconColor = '#344054', className, ...props }) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height="18"
    viewBox="0 0 17.8 17.8"
    width="18"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.15 8.9V12.75C17.15 14.2901 17.15 15.0602 16.8503 15.6485C16.5866 16.1659 16.1659 16.5866 15.6485 16.8503C15.0602 17.15 14.2901 17.15 12.75 17.15H5.05C3.50986 17.15 2.73978 17.15 2.15153 16.8503C1.63408 16.5866 1.21338 16.1659 0.949732 15.6485C0.65 15.0602 0.65 14.2901 0.65 12.75V8.9M5.23333 4.31667L8.9 0.65L12.5667 4.31667M8.9 0.65V11.65"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.3"
    />
  </svg>
);

ShareIcon.displayName = 'ShareIcon';
